var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.toggleSort}},[(_vm.currentSort === 'ASC')?_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-sort-ascending")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-sort-descending")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }